import packageJson from '../../../package.json'

export const sublosVersion = packageJson.sublosVersion
